import { coberturaEquipoEspecial, planes } from "../data/cotizadorCrData";
import { endPoints } from "../utils/constanst";
import { round, twoDecimal } from "../utils/helpers";
import http from "./http";

/*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
if (!Array.prototype.sum) {
    Array.prototype.sum = function (elemt) {
        if (elemt)
            return this.reduce((a, b) => (+a) + (+b[elemt]), 0);
        else
            return this.reduce((a, b) => (+a) + (+b), 0);
    };
}

const tarificar = planId => data => {

    return new Promise((resolve, reject) => {

        http(endPoints.tarificar(planId)).post(data).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });

    })

}

const getResumen = (tarifas = []) => {

    if (tarifas.length === 0) return 0;
    let totalPrima = 0
    tarifas.map(x => {
        let mrecargo = 0;
        let prima2 = 0;
        if (x.pRecargo > 0)
            mrecargo = parseFloat(parseFloat(x.prima).toFixed(2) * ((parseFloat(x.pRecargo) / 100).toFixed(2) + 1)).toFixed(2);
        prima2 = parseFloat(parseFloat(x.prima) + parseFloat(mrecargo)).toFixed(2);    
        totalPrima = totalPrima + parseFloat(prima2)  
    })
    return twoDecimal(totalPrima);
    // return tarifas.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');

}

const getDescuento = (tarifas = []) => {
    if (tarifas.length === 0) return 0;

    let totalDescuento = 0;
    tarifas.map(x => {
        let mrecargo = 0;
        let prima2 = 0;
        let descuento = 0;
        let pdescuento = 0;
        if (x.pRecargo > 0)
            mrecargo = parseFloat(parseFloat(x.prima).toFixed(2) * ((parseFloat(x.pRecargo) / 100).toFixed(2) + 1)).toFixed(2);
        prima2 = parseFloat(parseFloat(x.prima) + parseFloat(mrecargo)).toFixed(2);
        if (x.descuentos !== undefined && x.descuentos !== null && x.descuentos.length > 0)
            pdescuento = parseFloat(x.descuentos[0].porcentaje).toFixed(2);
        if (pdescuento !== 0)
            descuento = parseFloat(parseFloat(prima2) * (pdescuento / 100).toFixed(2)).toFixed(2);
        totalDescuento = totalDescuento + parseFloat(descuento)
    })
    // let test = tarifas.map(x => ({ descuento: twoDecimal(twoDecimal(twoDecimal(x.prima) * ((twoDecimal(x.pRecargo) / 100) + 1)) * (x.descuentos === 0 ? 0 : twoDecimal(x.descuentos.sum('porcentaje') / 100))) }))
    // console.log('x.test', test);
    // let descuento = tarifas.map(x => ({ descuento: twoDecimal(twoDecimal(twoDecimal(x.prima) * ((twoDecimal(x.pRecargo) / 100) + 1)) * (x.descuentos === 0 ? 0 : twoDecimal(x.descuentos.sum('porcentaje') / 100))) })).sum('descuento');

    return twoDecimal(totalDescuento);
}

const anexarCobertura = (tarifas, cobertura) => {
    if (tarifas == null)
        tarifas = { coverageIds: [] };

    let ids = JSON.parse(tarifas.coverageIds);
    if (cobertura.checked) {
        if (!ids.some(x => x == cobertura.cobId))
            ids.push(cobertura.cobId);
    }
    else {
        ids = ids.filter(x => x != cobertura.cobId);
    }

    let result = {
        ...tarifas,
        coverageIds: JSON.stringify(ids)
    };
    result[`Cob${cobertura.cobId}`] = cobertura.checked ? 1 : 0;

    if (cobertura.selectedSA == null) {
        //No borrar dato de cobertura especial, sino cuando se quite y ponga el check, no obtendra el valor(ultimo)
        delete result[`CobSA${cobertura.cobId}`];
        if (cobertura.cobId == coberturaEquipoEspecial)
            delete result[`SumEE`];
    }
    else {
        result[`CobSA${cobertura.cobId}`] = cobertura.selectedSA;
        if (cobertura.cobId == coberturaEquipoEspecial)
            result[`SumEE`] = cobertura.selectedSA;
    }

    return result;
}

const calculatePrima = prima => frecuencia => (+prima) / (+frecuencia)

const computeRateResult = (poliza, rates) => {

    // console.log(poliza);
    //console.log(rates);

    const prima = getResumen(rates);
    const descuento = getDescuento(rates);
    const primaCalutated = calculatePrima(prima);
    const _prima = parseFloat(primaCalutated(poliza.frecuenciaPagos)).toFixed(2);
    const primaNeta = prima - descuento;
    const impuesto = primaNeta * ((poliza.planId != planes.planDolares && poliza.planId != planes.planColones) ? 0.15 : 0.13);

    const interes = getInteres(poliza, prima, descuento);

    const mAnual = parseFloat(primaNeta + impuesto);
    var calculateFrecuency = _time => round((mAnual + ((primaNeta * findInteresByPlan(poliza, _time)) / 100)) / _time);

    const primaAnual = primaNeta + impuesto;
    const primaSemestral = calculateFrecuency(2);
    const primaTrimestral = calculateFrecuency(4);
    const primaMensual = calculateFrecuency(12);

    return {
        ...poliza,
        polCobs: rates,
        prima: parseFloat(prima).toFixed(2),
        descuento: descuento,
        primaNeta: parseFloat(primaNeta).toFixed(2),
        impuesto: parseFloat(impuesto).toFixed(2),
        mImpuesto1: parseFloat(impuesto).toFixed(2),
        primaDE: parseFloat(prima).toFixed(2),
        financiamiento: interes,
        total: parseFloat(primaNeta + impuesto + interes).toFixed(2),
        primeraCuota: parseFloat(_prima).toFixed(2),
        primaAnual: parseFloat(primaAnual).toFixed(2),
        primaSemestral: parseFloat(primaSemestral).toFixed(2),
        primaTrimestral: parseFloat(primaTrimestral).toFixed(2),
        primaMensual: parseFloat(primaMensual).toFixed(2),
        loading: false
    };
}

const getInteres = (poliza, prima, descuento) => {
    //CR
    if (poliza.planId == planes.planColones || poliza.planId == planes.planDolares) {
        let interes = 0;
        switch (poliza.frecuenciaPagos) {
            case "2":
                interes = 0.02; break;
            case "4":
                interes = 0.03; break;
            case "12":
                interes = 0.04; break;
            default:
                interes = 0;
        }
        if (poliza.planId == planes.planColones)
            interes = interes * 2;
        return parseFloat(((prima - descuento) * interes).toFixed(2));
    }
    return 0;
}

const findInteresByPlan = (poliza, time) => {
    let i = 1;
    switch (time) {
        case 2: i = 2; break;
        case 4: i = 3; break;
        case 12: i = 4; break;
    }
    if (poliza.planId == planes.planColones)
        i = i * 2;
    return i;
}


export { getResumen, calculatePrima, anexarCobertura, computeRateResult };

export default tarificar;
